import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { ShoppingCart, User, LogOut, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import AuthModal from '@/components/AuthModal';

const Navbar = () => {
  const { user, logout, cartCount, checkAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleAuthSuccess = () => {
    checkAuth();
  };

  return (
    <nav className="sticky top-0 z-50 glass border-b border-purple-900/20" data-testid="navbar">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_spring-mysql-shop/artifacts/w91br1kr_image.png" 
              alt="Skulls&Sheeps" 
              className="h-12 w-12 rounded-full"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
              SKULLS&SHEEPS
            </span>
          </Link>

          <div className="flex items-center space-x-6">
            <Link 
              to="/shop" 
              className="text-gray-300 hover:text-purple-400 transition-colors"
              data-testid="shop-link"
            >
              Tienda
            </Link>

            <Link 
              to="/cart" 
              className="relative text-gray-300 hover:text-purple-400 transition-colors"
              data-testid="cart-link"
            >
              <ShoppingCart size={24} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-purple-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center" data-testid="cart-count">
                  {cartCount}
                </span>
              )}
            </Link>

            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" className="flex items-center space-x-2" data-testid="user-menu">
                    <img 
                      src={user.picture || 'https://via.placeholder.com/40'} 
                      alt={user.name} 
                      className="h-8 w-8 rounded-full"
                    />
                    <span className="text-gray-300">{user.name}</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="bg-gray-900 border-purple-900/50 text-gray-300">
                  <DropdownMenuItem onClick={() => navigate('/orders')} data-testid="orders-link">
                    <User className="mr-2 h-4 w-4" />
                    Mis Órdenes
                  </DropdownMenuItem>
                  {user.role === 'admin' && (
                    <DropdownMenuItem onClick={() => navigate('/admin')} data-testid="admin-link">
                      <Shield className="mr-2 h-4 w-4" />
                      Panel Admin
                    </DropdownMenuItem>
                  )}
                  <DropdownMenuSeparator className="bg-purple-900/50" />
                  <DropdownMenuItem onClick={logout} data-testid="logout-button">
                    <LogOut className="mr-2 h-4 w-4" />
                    Cerrar Sesión
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Button 
                onClick={() => setShowAuthModal(true)} 
                className="bg-purple-600 hover:bg-purple-700 text-white"
                data-testid="login-button"
              >
                Iniciar Sesión
              </Button>
            )}
          </div>
        </div>
      </div>
      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)}
        onSuccess={handleAuthSuccess}
      />
    </nav>
  );
};

export default Navbar;